import { Link } from "react-router-dom/cjs/react-router-dom.min";
import AnPopup from "../../../cta_utils/AnPopup";
import { map_prospect } from "../api";
import { ALL_MAPPER_ACTIONS } from "../reducers/TempMapperReducer";
import { Button } from "../../../cta_utils/AnButton";
import { setState } from "../../../utils/CommonReducer";

export const SuggestionMapPopup = ({pageData, pageDataReducer, handlePopupClose}) => {
    const {currItem} = pageData
    const map = () => {
        map_prospect({mapper_ids: [currItem.id]}).then((response) => {
            pageDataReducer({type: ALL_MAPPER_ACTIONS['SET_STATE'], payload: {successMessages:{
                message: "Prospect mapped",
                duration: 3000
            }}})
            handlePopupClose();
            let temp_mappers = [...pageData.items].map((temp_mapper, index) => {
                if (temp_mapper.id === currItem.id) {
                    return {...temp_mapper,mapped: true };
                }
                return temp_mapper; 
            })
            setState(pageDataReducer)({items: [...temp_mappers], currItem: {}})
        })
    }
    const ProspectLink = ({prospect_id, name}) => {
        return (
            <Link to={`/prospects/${prospect_id}`} target="_blank"><span>{name}</span></Link>
        )
    } 
    const LinkedinProspectLink = ({ln_url, l_name}) => {
        return (
            <a href={ln_url} target="_blank"><span>{l_name}</span></a>
        )
    }
    const getMapperConflict = () => {
        switch(currItem.mapper_conflict){
            case "prospect_conflict": {
                return (
                <div>
                    <div>
                        This prospect (<ProspectLink prospect_id={currItem.prospect_id} name={currItem.name}/>) is currently mapped to another LinkedIn user (<LinkedinProspectLink ln_url={currItem.mapped_url} l_name={currItem.prospect_l_name}/>).
                    </div><br/>
                    <div>
                        Would you like to unmap the existing LinkedIn user and map it to <LinkedinProspectLink ln_url={currItem.linkedin_url} l_name={currItem.l_name}/> instead?
                    </div>
                </div>
                )
            }
            case "l_prospect_conflict": {
                return (
                <div>
                    <div>This LinkedIn user (<LinkedinProspectLink ln_url={currItem.linkedin_url} l_name={currItem.l_name}/>) is currently mapped to another prospect (<ProspectLink prospect_id={currItem.l_prospect_id} name={currItem.l_prospect_name}/>).</div><br/>
                    <div>Would you like to unmap this LinkedIn user from {currItem.l_prospect_name} and map it to {currItem.name} instead?</div>
                </div>
                )
            }
            case "all_conflict": {
                return (
                <div>
                    <div>This prospect (<ProspectLink prospect_id={currItem.prospect_id} name={currItem.name}/>) is mapped to another LinkedIn user (<LinkedinProspectLink ln_url={currItem.mapped_url} l_name={currItem.prospect_l_name}/>), 
                    and this LinkedIn user (<LinkedinProspectLink ln_url={currItem.linkedin_url} l_name={currItem.l_name}/>) is also mapped to another prospect (<ProspectLink prospect_id={currItem.l_prospect_id} name={currItem.l_prospect_name}/>).</div><br/>
                    <div>Would you like to unmap both and create a new mapping between {currItem.name} and {currItem.l_name}?</div>
                </div>
                )
            }
            default: return <div></div>;
        }
    }
    return(
        <AnPopup 
            name="mapConfirmationPopup"
            handleOnClosePopup={handlePopupClose}
            maxWidth={480}
        >
            {currItem.mapper_conflict === 'no_conflict' ? 
            <div className="text_body text_center">Do you want to map this?</div>
            :
            <div>
                <div className="text_body_bold" style={{color: '#E76C7B'}}>Mapping Conflict Detected</div>
                <div  className="line_seperator_ex_light_grey"  style={{ margin: "10px auto" }}></div>
                <div className="text_subtitle_charcoal_semi_bold" style={{textAlign: 'center', marginTop: 8}}>{getMapperConflict()}</div>
            </div>
            }
            <div style={{display: 'flex', marginTop: 16, alignContent: 'center', justifyContent: 'center'}}>
                <Button buttonSize="Medium" buttonStyle={{width: 'max-content'}} innerButtonStye={{padding: '8px 20px'}}
                        onClick={() => map()}>Map</Button>
                <Button type="Secondary" buttonSize="Medium" buttonStyle={{width: 'max-content', marginLeft: 16}} innerButtonStye={{padding: '8px 20px'}}
                        onClick={handlePopupClose}>Cancel</Button>
            </div>
        </AnPopup>
        )
}